import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { GlobalSearch } from '../components/GlobalSearch';
import { SupportNotifyBridge } from '../components/SupportNotifyBridge';
import { useAuth } from '../hooks/useAuth';

const navItems = [
  { to: '/', label: 'Dashboard' },
  { to: '/users', label: 'Пользователи' },
  { to: '/support', label: 'Поддержка' },
  { to: '/vpn', label: 'VPN' },
  { to: '/servers', label: 'Серверы' },
  { to: '/payments', label: 'Платежи' },
  { to: '/promos', label: 'Промокоды' },
  { to: '/tariffs', label: 'Тарифы' },
  { to: '/referral-rules', label: 'Рефералы' },
  { to: '/settings', label: 'Настройки' },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const displayName = user?.first_name ?? user?.username ?? String(user?.telegram_user_id ?? '');

  return (
    <div className={`admin-shell${menuOpen ? ' is-menu-open' : ''}`}>
      {menuOpen && (
        <button
          type="button"
          className="admin-backdrop"
          aria-label="Закрыть меню"
          onClick={() => setMenuOpen(false)}
        />
      )}

      <aside className="admin-sidebar" aria-label="Навигация">
        <div className="admin-brand">
          <strong>VPN Panel</strong>
          <span className="admin-brand-sub">Control panel</span>
        </div>

        <nav className="admin-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `admin-nav-link${isActive ? ' is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-name">{displayName}</div>
          <div className="admin-user-role">{user?.role}</div>
          <button type="button" className="btn btn-ghost admin-logout-btn" onClick={() => void logout()}>
            Выйти
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-topbar">
          <button
            type="button"
            className="btn btn-ghost admin-menu-btn"
            aria-expanded={menuOpen}
            aria-label="Меню"
            onClick={() => setMenuOpen((v) => !v)}
          >
            ☰
          </button>
          <div className="admin-search-wrap">
            <GlobalSearch />
          </div>
          <div className="admin-topbar-user" title={displayName}>
            <span className="admin-topbar-name">{displayName}</span>
            <span className="badge badge-muted">{user?.role}</span>
          </div>
        </header>

        <div className="admin-content">
          <SupportNotifyBridge />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
